module.exports = __webpack_public_path__ + "img/facebook_icon.76b40c68.svg";